<!-- Banner -->
<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Contact Us</h1>
                </div>
                <p>
                    Contact us with general questions, to request a bid on your project, or to submit a job application. The P.C. Haines team is here to assist you.
                </p>
            </div>


            <div class="form-container">

                <div class="forms-group">

                    @if (showGeneralContact) {
                        <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit('contactUsForm')"  [ngClass]="{'disabled': submitting}" id="generalContactForm">
                            <h2>General Contact</h2>
                            <div class="form-row">
                                <!-- trap -->
                                <input type="text" name="" id="hp-general" class="hp" formControlName="hpName" autocomplete="off" tabindex="-1">
                                <div class="form-group">
                                    <label for="firstName">First Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="First Name" id="firstName" formControlName="firstName">
                                    <div [hidden]="!generalFormHasError('firstName')" class="alert alert-danger">
                                        {{errorMessage(generalFormControls.firstName.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="lastName">Last Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Last Name" id="lastName" formControlName="lastName">
                                    <div [hidden]="!generalFormHasError('lastName')" class="alert alert-danger">
                                        {{errorMessage(generalFormControls.lastName.errors)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="email">Email Address<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Email Address" id="email" formControlName="email">
                                <div [hidden]="!generalFormHasError('email')" class="alert alert-danger">
                                    {{errorMessage(generalFormControls.email.errors)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="phone">Phone Number<span class="highlight">*</span></label>
                                <input maxlength="14" type="text" class="form-control" placeholder="Phone Number" id="phone" formControlName="phone" (change)="updatePhoneDisplayInForm('contactUsForm')" (keyup)="updatePhoneDisplayInForm('contactUsForm')">
                                <div [hidden]="!generalFormHasError('phone')" class="alert alert-danger">
                                    {{errorMessage(generalFormControls.phone.errors)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="message">Message<span class="highlight">*</span></label>
                                <textarea type="text" class="form-control" placeholder="How can we help?" id="message" formControlName="message" rows="4" cols="50"></textarea>
                                <div [hidden]="!generalFormHasError('message')" class="alert alert-danger">
                                    {{errorMessage(generalFormControls.message.errors)}}
                                </div>
                            </div>
                            <button [disabled]="!contactUsForm.valid || submitting" type="submit">
                                @if (submitting) {
                                    Submitting
                                    <pc-spinner></pc-spinner>
                                } 
                                @else {
                                    Submit
                                }
                            </button>
                        </form>
                    }

                    @if (showBidRequestContact) {
                        <form [formGroup]="bidRequestForm" (ngSubmit)="onSubmit('bidRequestForm')" [ngClass]="{'disabled': submitting}" id="bidRequestForm">
                            <h2>Bid Request</h2>
                            
                            <h3>Contact Information</h3>    
                            <div class="form-group">
                                <!-- trap -->
                                <input type="text" name="" id="hp-bid" class="hp" formControlName="hpName" autocomplete="off" tabindex="-1">
                                <label for="companySponsor">Company / Sponsor<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Company or Sponsor Name" id="companySponsor" formControlName="companySponsor">
                                <div [hidden]="!bidFormHasError('companySponsor')" class="alert alert-danger">
                                    {{errorMessage(bidFormControls.companySponsor.errors)}}
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="firstName">First Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="First Name" id="firstName" formControlName="firstName">
                                    <div [hidden]="!bidFormHasError('firstName')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.firstName.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="lastName">Last Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Last Name" id="lastName" formControlName="lastName">
                                    <div [hidden]="!bidFormHasError('lastName')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.lastName.errors)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="address1">Address Line 1<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Address Line 1" id="address1" formControlName="address1">
                                <div [hidden]="!bidFormHasError('address1')" class="alert alert-danger">
                                    {{errorMessage(bidFormControls.address1.errors)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="address2">Address Line 2</label>
                                <input type="text" class="form-control" placeholder="Apt. / Suite / P.O. Box" id="address2" formControlName="address2">
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="city">City<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="City" id="city" formControlName="city">
                                    <div [hidden]="!bidFormHasError('city')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.city.errors)}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="state">State<span class="highlight">*</span></label>
                                    <select class="form-control" id="state" formControlName="state">
                                        <option value="" disabled selected>Select One</option>
                                        @for (stateName of stateList; track $index) {
                                            <option [value]="stateName">{{stateName}}</option>
                                        }
                                    </select>
                                    <div [hidden]="!bidFormHasError('state')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.state.errors)}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email">Email Address<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Email Address" id="email" formControlName="email">
                                <div [hidden]="!bidFormHasError('email')" class="alert alert-danger">
                                    {{errorMessage(bidFormControls.email.errors)}}
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="phone">Phone Number<span class="highlight">*</span></label>
                                    <input maxlength="14" type="text" class="form-control" placeholder="Phone Number" id="phone" formControlName="phone" (change)="updatePhoneDisplayInForm('bidRequestForm')" (keyup)="updatePhoneDisplayInForm('bidRequestForm')">
                                    <div [hidden]="!bidFormHasError('phone')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.phone.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="fax">Fax Number</label>
                                    <input type="text" class="form-control" placeholder="Fax Number" id="fax" formControlName="fax">
                                </div>
                            </div>

                            <h3>Job Information</h3>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="jobName">Job Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Job Name" id="jobName" formControlName="jobName">
                                    <div [hidden]="!bidFormHasError('jobName')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobName.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="jobType">Job Type<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Job Type" id="jobType" formControlName="jobType">
                                    <div [hidden]="!bidFormHasError('jobType')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobType.errors)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="jobLocation">Job Location<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Job Location" id="jobLocation" formControlName="jobLocation">
                                    <div [hidden]="!bidFormHasError('jobLocation')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobLocation.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="jobEstBudget">Estimate Budget<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Estimate Budget ($)" id="jobEstBudget" formControlName="jobEstBudget">
                                    <div [hidden]="!bidFormHasError('jobEstBudget')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobEstBudget.errors)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="jobStartDate">Anticipated Start Date<span class="highlight">*</span></label>
                                    <input type="date" class="form-control date-control" placeholder="Anticipated Start Date" id="jobStartDate" formControlName="jobStartDate">
                                    <div [hidden]="!bidFormHasError('jobStartDate')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobStartDate.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="jobDuration">Anticipated Duration<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Anticipated Duration" id="jobDuration" formControlName="jobDuration">
                                    <div [hidden]="!bidFormHasError('jobDuration')" class="alert alert-danger">
                                        {{errorMessage(bidFormControls.jobDuration.errors)}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                            <label for="bidFile">File Upload (PDF or Image)</label>
                            <input
                                type="file"
                                accept="application/pdf,image/*"
                                class="form-control"
                                id="bidFile"
                                (change)="onBidRequestFormFileChange($event)"
                            >

                            <div [hidden]="!bidFormHasError('file')" class="alert alert-danger">
                                {{ errorMessage(bidFormControls.file.errors) }}
                            </div>
                            </div>

                            <div class="form-group">
                                <label for="message">Message</label>
                                <textarea type="text" class="form-control" placeholder="Any additional comments?" id="message" formControlName="message" rows="4" cols="50"></textarea>
                            </div>
            
                            <button [disabled]="!bidRequestForm.valid || submitting" type="submit">
                                @if (submitting) {
                                    Submitting
                                    <pc-spinner></pc-spinner>
                                } 
                                @else {
                                    Submit
                                }
                            </button>
                        </form>
                    }

                    @if (showCareerContact) {
                        <form [formGroup]="careersForm" (ngSubmit)="onSubmit('careersForm')" [ngClass]="{'disabled': submitting}" id="careersForm">
                            <h2>Careers</h2> 
                            <div class="form-row">
                                <!-- trap -->
                                <input type="text" name="" id="hp-career" class="hp" formControlName="hpName" autocomplete="off" tabindex="-1">
                                <div class="form-group">
                                    <label for="firstName">First Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="First Name" id="firstName" formControlName="firstName">
                                    <div [hidden]="!careerFormHasError('firstName')" class="alert alert-danger">
                                        {{errorMessage(careersFormControls.firstName.errors)}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="lastName">Last Name<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="Last Name" id="lastName" formControlName="lastName">
                                    <div [hidden]="!careerFormHasError('lastName')" class="alert alert-danger">
                                        {{errorMessage(careersFormControls.lastName.errors)}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="address1">Address Line 1<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Address Line 1" id="address1" formControlName="address1">
                                <div [hidden]="!careerFormHasError('address1')" class="alert alert-danger">
                                    {{errorMessage(careersFormControls.address1.errors)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="address2">Address Line 2</label>
                                <input type="text" class="form-control" placeholder="Apt. / Suite / P.O. Box" id="address2" formControlName="address2">
                            </div>
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="city">City<span class="highlight">*</span></label>
                                    <input type="text" class="form-control" placeholder="City" id="city" formControlName="city">
                                    <div [hidden]="!careerFormHasError('city')" class="alert alert-danger">
                                        {{errorMessage(careersFormControls.city.errors)}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="state">State<span class="highlight">*</span></label>
                                    <select class="form-control" id="state" formControlName="state">
                                        <option value="" disabled selected>Select One</option>
                                        @for (stateName of stateList; track $index) {
                                            <option [value]="stateName">{{stateName}}</option>
                                        }
                                    </select>
                                    <div [hidden]="!careerFormHasError('state')" class="alert alert-danger">
                                        {{errorMessage(careersFormControls.state.errors)}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email">Email Address<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="Email Address" id="email" formControlName="email">
                                <div [hidden]="!careerFormHasError('email')" class="alert alert-danger">
                                    {{errorMessage(careersFormControls.email.errors)}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="phone">Phone Number<span class="highlight">*</span></label>
                                <input maxlength="14" type="text" class="form-control" placeholder="Phone Number" id="phone" formControlName="phone" (change)="updatePhoneDisplayInForm('careersForm')" (keyup)="updatePhoneDisplayInForm('careersForm')">
                                <div [hidden]="!careerFormHasError('phone')" class="alert alert-danger">
                                    {{errorMessage(careersFormControls.phone.errors)}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="position">What position are you seeking?<span class="highlight">*</span></label>
                                <input type="text" class="form-control" placeholder="What position are you seeking?" id="position" formControlName="position">
                                <div [hidden]="!careerFormHasError('position')" class="alert alert-danger">
                                    {{errorMessage(careersFormControls.position.errors)}}
                                </div>
                            </div>

                            <div class="form-group">
                            <label for="careerFile">Resume Upload (PDF or Image)<span class="highlight">*</span></label>
                            <input
                                type="file"
                                accept="application/pdf,image/*"
                                class="form-control"
                                id="careerFile"
                                (change)="onCareersFormFileChange($event)"
                            >

                            <div [hidden]="!careerFormHasError('file')" class="alert alert-danger">
                                {{ errorMessage(careersFormControls.file.errors) }}
                            </div>
                            </div>

            
                            <button [disabled]="!careersForm.valid || submitting" type="submit">
                                @if (submitting) {
                                    Submitting
                                    <pc-spinner></pc-spinner>
                                } 
                                @else {
                                    Submit
                                }
                            </button>
                        </form>
                    }
                    
                    <!-- @if (showFeedbeck) { -->
                    <div class="feedback-container success" [ngClass]="{'show': showFeedbeck, 'success': isSuccessful, 'failure': isFailure}">
                        @if (isSuccessful) {
                            <p>Thank you for your 
                                @if (showGeneralContact) {General Contact}
                                @if (showBidRequestContact) {Bid Request}
                                @if (showCareerContact) {Careers Inquiry}
                                submission! A representative from P.C. Haines will contact you as soon as possible.
                            </p>
                        }
                        @if (isFailure) {
                            <p>We're sorry, but there was an error processing your 
                                @if (showGeneralContact) {General Contact}
                                @if (showBidRequestContact) {Bid Request}
                                @if (showCareerContact) {Careers Inquiry}
                                submission. Please try again later or contact us directly.
                            </p>
                        }
                    </div>
                    <!-- } -->

                </div>
    
    
                <div class="form-card-container">
                    @if (!showBidRequestContact) {
                        <div class="form-card bid-card">
                            <h2>Bid Request</h2>
                            <p>We at PC Haines, Inc. appreciate your interest in our work and are ready to serve you as your trusted wall and ceiling contractor.</p>
        
                            <button (click)="showBidRequestContactForm()" [disabled]="submitting">Submit a Request</button>
                        </div>
                    }
                    @if (!showCareerContact) {
                        <div class="form-card career-card">
                            <h2>Careers</h2>
                            <p>Are you ready for a rewarding career with PC Haines? We value industry  experience, quality workmanship, attention to detail, and a team  mindset.</p>
        
                            <button (click)="showCareersContactForm()" [disabled]="submitting">Submit Your Resume</button>
                        </div>
                    }
                    @if (!showGeneralContact) {
                        <div class="form-card general-card">
                            <h2>Contact Us</h2>
                            <p>Get in touch with us today for wall and ceiling contractor services.</p>
        
                            <button (click)="showGeneralContactForm()" [disabled]="submitting" class="black-button">Submit a Message</button>
                        </div>
                    }
                </div>
    
            </div>
    
            <div class="circles contact-circles">
                <pc-project-circles></pc-project-circles>
            </div>


        </div>
    </div>
</div>
